// 商品路由
const name = '資訊管理'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/dealer/adapay_member',
  component: Layout,
  children: [
    // {
    //   path: 'entry',
    //   name: `開戶管理`,
    //   component: () => import( '@/view/dealer/create_account.vue' )
    // },
    {
      path: 'info',
      name: `開戶資訊`,
      component: () => import('@/view/mall/marketing/dealer_accountopen')
    }
  ]
}
